module.exports = __webpack_public_path__ + "static/badger-56148f3191beb60f1512fdfecb718490.jpeg";